var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.175 1.857c.835 0 1.626.326 2.217.916l1.987 1.988a3.19 3.19 0 0 1 .905 2.02l.008.193v8.443a2.71 2.71 0 0 1-2.709 2.708h-8.75a.625.625 0 0 1-.172-.024l-.122-.01a2.292 2.292 0 0 1-2.01-2.137l-.004-.139V4.565a2.698 2.698 0 0 1 2.708-2.708zm-.309 1.25H6.233c-.813 0-1.458.645-1.458 1.458v11.25c0 .575.465 1.042 1.042 1.042l.043.001.044.005.06.012h8.62a1.46 1.46 0 0 0 1.453-1.339l.005-.12-.001-8.125h-2.3a1.88 1.88 0 0 1-1.87-1.747l-.004-.127-.001-2.31zm-2.245 9.08c.21.233.215.58.022.816l-.064.068-1.108 1.008a.625.625 0 0 1-.762.061l-.076-.057-.55-.492a.625.625 0 0 1 .76-.988l.074.056.129.116.692-.629a.625.625 0 0 1 .883.042zm3.712.521a.625.625 0 0 1 .085 1.245l-.085.005h-1.666a.625.625 0 0 1-.085-1.244l.085-.006h1.666zM9.621 8.854c.21.233.215.58.022.816l-.064.067-1.108 1.009a.625.625 0 0 1-.762.06l-.076-.057-.55-.491a.625.625 0 0 1 .76-.989l.074.057.129.116.692-.63a.625.625 0 0 1 .883.042zm3.712.521a.625.625 0 0 1 .085 1.244l-.085.006h-1.666a.625.625 0 0 1-.085-1.244l.085-.006h1.666zm-.216-6.019v2.06a.63.63 0 0 0 .54.62l.085.006h2.05a1.897 1.897 0 0 0-.3-.4l-1.984-1.984-.123-.114a1.873 1.873 0 0 0-.268-.188z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChecklist);
export default __webpack_public_path__ + "static/media/icons-checklist.93de3c99b4cf8a4e4ddbca333cecb1fd.svg";
export { ForwardRef as ReactComponent };